type Props = {
  help?: string;
  error?: string;
};

const TicketFieldHint = ({ help, error }: Props) => (
  <>
    {help ? <div className="text-gray-600 fs-8 mt-1">{help}</div> : null}
    {error ? <div className="text-danger fs-8 mt-1">{error}</div> : null}
  </>
);

export default TicketFieldHint;
